/**
 * VIEW-CONFIG PAGE KEYS — a leaf, on purpose.
 *
 *      viewConfigPages.ts  ── imports NOTHING
 *              ▲
 *              ├── grids/views/viewConfig.store.ts re-exports VIEW_PAGES
 *              ├── managers/viewConfigPages.ts    shim (FU-RX-VC)
 *              └── utils/usePersistedLensedStore.ts
 *
 * `viewConfig.store.ts` calls `createUseStoreState` at module scope, so any
 * module reachable from `createUseStoreState` must not reach back into the
 * store. These keys are reachable from both sides.
 *
 * ⚠ Never add an import to this file.
 */
export enum VIEW_PAGES {
  INVENTORY = 'inventory',
  INVOICES = 'invoices',
  PAYABLES = 'payables',
  PURCHASE_ORDERS = 'purchase-orders-v2',
  SALES_ORDERS = 'sales-orders-v2',
  GROWER_PRODUCTS = 'grower-products-v2',
  PICK_TICKETS = 'pick-tickets-v2',
  RECEIVING_TICKETS = 'receiving-tickets-v2',
  PRODUCTION_RUNS = 'production-runs-v2',
  ACCOUNT_REGISTER = 'account-register',
  CUSTOMER_PORTAL_PUCHASE_ORDERS = 'customer-portal-purchase-orders',
  CUSTOMER_PORTAL_INVOICES = 'customer-portal-invoices',
  PAYMENTS = 'payments',
}
